const constants = {
  ACTIONS: {
    SET_PROFILE_DATA: "SET_PROFILE_DATA",
  } as { [key: string]: ProfileStore.eActionType },
};

export default constants;
